module.exports = __webpack_public_path__ + "media/images/ok-fcb8806e017dfd3639daffe712052088.png";